import type { ComparisonMode } from '@/core/components/date-range-picker.types';

export function pct(rate: number): string {
  return `${Math.round(rate * 100)}%`;
}

/**
 * Resolve the comparison window (same length, immediately before, or one year
 * earlier). Returns null when comparison is off or the range has no start.
 */
export function comparisonWindow(
  from: string | undefined,
  to: string | undefined,
  mode: ComparisonMode,
): { from: string; to: string } | null {
  if (mode === 'none' || !from) return null;
  const fromD = new Date(from);
  const toD = to ? new Date(to) : new Date();
  if (mode === 'prevYear') {
    const pf = new Date(fromD);
    pf.setFullYear(pf.getFullYear() - 1);
    const pt = new Date(toD);
    pt.setFullYear(pt.getFullYear() - 1);
    return { from: pf.toISOString(), to: pt.toISOString() };
  }
  const length = toD.getTime() - fromD.getTime();
  return {
    from: new Date(fromD.getTime() - length).toISOString(),
    to: new Date(fromD.getTime() - 1).toISOString(),
  };
}

const MINUS = '\u2212';

/** Relative change for count-like metrics, rendered as a percentage. */
export function deltaCount(
  current: number,
  previous: number,
): { direction: number; text: string } {
  const diff = current - previous;
  const ratio = previous === 0 ? (current > 0 ? 1 : 0) : diff / previous;
  return {
    direction: diff,
    text: `${diff >= 0 ? '+' : MINUS}${Math.abs(Math.round(ratio * 100))}%`,
  };
}

/** Relative change for 0..1 rates — same % badge style as review counts. */
export function deltaRate(
  current: number,
  previous: number,
): { direction: number; text: string } {
  const diff = current - previous;
  const ratio = previous === 0 ? (current > 0 ? 1 : 0) : diff / previous;
  return {
    direction: diff,
    text: `${diff >= 0 ? '+' : MINUS}${Math.abs(Math.round(ratio * 100))}%`,
  };
}
